// src/stone/illustrations/AnimationChatIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var AnimationChatIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 96 96",
    ...props,
    children: [
      /* @__PURE__ */ jsx("circle", { cx: 48, cy: 48, r: 48, fill: "#EFF4F8" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M30.688 48.895a3.41 3.41 0 0 0 3.154 3.646l18.17 1.318 42.914 3.111c.913.066 1.425-1.022.796-1.685l-6.855-7.18 1.796-24.752a3.41 3.41 0 0 0-3.155-3.646l-51.017-3.698a3.41 3.41 0 0 0-3.646 3.155l-2.03 27.979z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M79.362 46.006h-.02L41.437 42.89a.26.26 0 0 1-.236-.279.26.26 0 0 1 .279-.236l37.902 3.116a.258.258 0 0 1-.021.516M76.11 37.277h-.022l-11.954-.99a.26.26 0 0 1-.237-.28.26.26 0 0 1 .28-.236l11.954.99a.258.258 0 0 1-.02.516"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M68.04 55.023 63 41.389l-.666 13.206zM80.714 29.687h-.02l-39.651-3.26a.26.26 0 0 1-.236-.28.257.257 0 0 1 .279-.236l39.65 3.26a.258.258 0 0 1-.022.516M61.552 36.072h-.02l-21.234-1.758a.26.26 0 0 1-.236-.28.26.26 0 0 1 .279-.235l21.234 1.757a.258.258 0 0 1-.023.516"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M65.312 71.923a3.41 3.41 0 0 1-3.154 3.646l-18.17 1.317-42.914 3.112c-.913.065-1.425-1.023-.796-1.685l6.855-7.18-1.796-24.75a3.41 3.41 0 0 1 3.155-3.647l51.016-3.7a3.41 3.41 0 0 1 3.647 3.155l2.03 27.98z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M16.583 68.93a.258.258 0 0 1-.02-.515l23.349-1.792a.254.254 0 0 1 .278.238.26.26 0 0 1-.238.277l-23.35 1.792zM16.11 60.423a.258.258 0 0 1-.019-.515l33.709-2.59a.255.255 0 0 1 .278.239.26.26 0 0 1-.238.277l-33.71 2.588zM15.318 52.604a.258.258 0 0 1-.019-.516l23.862-1.832a.255.255 0 0 1 .278.238.26.26 0 0 1-.238.278l-23.864 1.83q-.01.002-.019.002M42.373 50.525a.258.258 0 0 1-.019-.516l12.613-.97a.255.255 0 0 1 .278.239.26.26 0 0 1-.238.277l-12.613.97z"
        }
      )
    ]
  }
);
var AnimationChatIllustration_default = AnimationChatIllustration;

export {
  AnimationChatIllustration,
  AnimationChatIllustration_default
};
